__turbopack_context__.v({
  "className": "inter_c6e48ee1-module__JRO3KW__className",
  "variable": "inter_c6e48ee1-module__JRO3KW__variable",
});
